<Modal
    bind:enabled={enabled} 
    confirmButtonType="secondary"
    confirmText={i18n.close}
    scrollBody={false}
    showCancel={false}
    titleText={formatLanguageString(i18n.sharingModalTitle, objectName)} >

    <ContainerWithGap slot="body" cssClass="itsl-sharing-modal">
        <h3>{i18n.publicLink}</h3>
        <p>{publicLink}</p>
        <ButtonGroup>
            <IconButton
                iconClass="itsl-common-sharing__copy-icon"
                text={i18n.copyPublicLink}
                type="secondary"
                on:click={onCopyPublicLinkClicked} />
            <p>{linkCopiedMessage}</p>
        </ButtonGroup>
        
        <h3>{i18n.qrCode}</h3>
        <div bind:this={qrcode} class="itsl-common-sharing__qr-container"></div>
        <ButtonGroup>
            <IconButton
                iconClass="itsl-common-sharing__copy-icon"
                text={i18n.copyQrCode}
                type="secondary"
                on:click={onCopyQrCodeClicked} />
            <p>{qrCopiedMessage}</p>
        </ButtonGroup>
        <div></div>
    </ContainerWithGap>
    
</Modal>

<script>

    import ButtonGroup from '@itslearning/prometheus/assets/inputs/ButtonGroup/v1/ButtonGroup.svelte';
    import ContainerWithGap from '@its-ui/common-components/ContainerWithGap/ContainerWithGap.svelte';
    import IconButton from '@itslearning/prometheus/assets/inputs/IconButton/v1/IconButton.svelte';
    import Modal from '@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte';

    import { formatLanguageString } from "@itslearning/atlas/strings/format.js";
    import { QRCode } from './utils/qrcode.js';
    
    /**
     * @typedef {Object} SharingModalTerms
     * @property {string} close
     * @property {string} copyPublicLink
     * @property {string} copyQrCode
     * @property {string} linkCopiedToClipboard
     * @property {string} publicLink
     * @property {string} qrCode
     * @property {string} qrCopiedToClipboard
     * @property {string} sharingModalTitle
     */

     /** @type {SharingModalTerms} */
    export let i18n;
    export let enabled = false;
    export let publicLink = "";
    export let objectName = "";
    
    let qrcode;
    /** @type {string} */
    let linkCopiedMessage;
    /** @type {string} */
    let qrCopiedMessage;

    $: if (enabled && qrcode) {
        linkCopiedMessage = "";
        qrCopiedMessage = "";

        const qrCodeArea = qrcode;
        new QRCode(
            qrCodeArea, 
            {
                text : publicLink,
                width : 160,
                height : 160
            });
    }

    function onCopyPublicLinkClicked() {
        navigator.clipboard.writeText(publicLink);

        linkCopiedMessage = i18n.linkCopiedToClipboard;
        qrCopiedMessage = "";
    }

    async function onCopyQrCodeClicked() {
        const img = qrcode.querySelector('img');

        const dataUrl = img.src;
        const response = await fetch(dataUrl);
        const blob = await response.blob();

        const item = new ClipboardItem({ [blob.type]: blob });
        await navigator.clipboard.write([item]);

        linkCopiedMessage = "";
        qrCopiedMessage = i18n.qrCopiedToClipboard;
    }
</script>
